/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * Where are we getting the request form
 */
export type SoChannel = (typeof SoChannel)[keyof typeof SoChannel]

export const SoChannel = {
  MyAccount: "MyAccount",
  Nova: "Nova",
} as const
